@let savingValue = saving();
@let infoToEditValue = infoToEdit();
<mat-card appearance="outlined">
  <h2>{{ 'PRODUCT.USERADMIN.THRESHOLDS.TITLE' | translate }}</h2>
  <div class="text-description">
    {{ 'PRODUCT.USERADMIN.THRESHOLDS.DESCRIPTION' | translate }}
  </div>

  <div class="card-grid">
    @let allowedParametersValue = allowedParameters();
    @for (
      warnParameter of WarnParameter | keyvalue: compare.bind(this);
      track warnParameter.key
    ) {
      @if (warnParameter.key | isParameterAllowed: allowedParametersValue) {
        <mat-card appearance="outlined" class="warn-card">
          <h3>
            {{
              'PRODUCT.USERADMIN.THRESHOLDS.' + warnParameter.value | translate
            }}
          </h3>
          <ng-template #levelBlock let-currentLevel="currentLevel">
            <div
              class="level-row"
              role="tablist"
              aria-label="Warn-Level auswählen">
              @for (level of levels; track level) {
                <button
                  mat-icon-button
                  class="level-button"
                  [class.selected]="currentLevel === level"
                  [disabled]="savingValue"
                  (click)="onSelectLevel(warnParameter.key, level)"
                  [attr.aria-label]="'Level ' + level"
                  [attr.aria-selected]="currentLevel === level"
                  role="tab">
                  <fa-icon [icon]="$any(levelIcons[level])"></fa-icon>
                  <span class="visually-hidden"
                    >Level {{ level }} - {{ currentLevel }}</span
                  >
                </button>
              }
            </div>

            <div class="level-texts">
              @if (currentLevel === 0) {
                <div class="level-label">
                  {{ 'PRODUCT.USERADMIN.THRESHOLDS.LEVEL.0' | translate }}
                </div>
              }

              @if (currentLevel > 0) {
                <div class="level-label">
                  {{ 'PRODUCT.USERADMIN.THRESHOLDS.LEVEL.TITLE' | translate }}
                  {{ currentLevel }}
                </div>

                <div class="level-description">
                  {{
                    'PRODUCT.USERADMIN.THRESHOLDS.LEVEL.' +
                      warnParameter.value +
                      '.' +
                      currentLevel | translate
                  }}
                </div>
              }
            </div>
          </ng-template>
          <ng-container
            [ngTemplateOutlet]="levelBlock"
            [ngTemplateOutletContext]="{
              currentLevel:
                warnParameter.key | getWarnLevel: thresholdsToEdit(),
            }">
          </ng-container>
        </mat-card>
      }
    }
    @if ('info' | isParameterAllowed: allowedParametersValue) {
      <mat-card appearance="outlined" class="warn-card">
        <h3>
          {{ 'PRODUCT.WARNING.TYPE.VORAB' | translate }}
        </h3>
        <div class="level-row" role="tablist" aria-label="Warn-Level auswählen">
          <button
            mat-icon-button
            class="level-button"
            [class.selected]="!infoToEditValue"
            [disabled]="savingValue"
            (click)="onChangeWarnInfo(false)"
            [attr.aria-label]="'Off'"
            [attr.aria-selected]="!infoToEditValue"
            role="tab">
            <fa-icon [icon]="['fal', 'bell-slash']"></fa-icon>
            <span class="visually-hidden">NEIN</span>
          </button>
          <button
            mat-icon-button
            class="level-button"
            [class.selected]="infoToEditValue"
            [disabled]="savingValue"
            (click)="onChangeWarnInfo(true)"
            [attr.aria-label]="'On'"
            [attr.aria-selected]="infoToEditValue"
            role="tab">
            <fa-icon [icon]="['fal', 'bell']"></fa-icon>
            <span class="visually-hidden">JA</span>
          </button>
        </div>
        <div class="level-texts">
          <div class="level-label">
            {{
              'PRODUCT.USERADMIN.THRESHOLDS.' +
                (infoToEditValue ? 'warninfo' : 'noinfo') | translate
            }}
          </div>
        </div>
      </mat-card>
    }
  </div>
</mat-card>
